<template>
  <ScrollKeyFrame id="Font2014" class="font-project" :nav-list="sectionList">
    <section class="section-1 main-section">
      <div class="scroll-mark"></div>
      <div class="contents-wrapper">
        <div class="type-main-title h1">2015</div>
        <div class="type-main-description">
          <span>가비아 솔미체 <span class="x-mark hidden collaboration small"></span> 가비아 봄바람체 <span class="x-mark hidden collaboration small"></span> 가비아 납작블럭체</span>
        </div>
      </div>
      <video autoplay muted playsinline loop poster="https://static.gabia.com/fonts/project/video/sub_01_poster.png">
        <source src="https://static.gabia.com/fonts/project/video/sub_1.mp4" />
      </video>
    </section>
    <section class="section-2" id="qna" @mouseenter="autoPlay(true)" @mouseleave="autoPlay(false)">
      <div class="section-contents-wrapper">
        <div class="section-title align-left" data-aos="fade-up" data-aos-duration="1000" data-aos-offset="120">
          <span class="title">질문과 답변</span>
        </div>
        <div class="section-contents-tab" data-aos="fade-up" data-aos-duration="1000" data-aos-offset="120">
          <div class="tab-control-menu">
            <div class="tab-control-item" v-for="item in qnaList.length" :key="item" @click="setQna(item)" :class="{active: selectedId === item - 1}">
              <span class="control-number">0{{item}}</span>
              <span class="active-line"></span>
            </div>
          </div>
          <div class="tab-contents-panel line-card-wrapper">
            <h4 class="panel-header">
              <span>Q.</span>
              <span>{{ qnaList[selectedId].question }}</span>
            </h4>
            <div class="panel-contents font-24">{{ qnaList[selectedId].answer }}</div>
          </div>
          <div class="reference-text">
            <div class="message">* 본 내용은 디자인 정글 매거진 기사 [가비아X국민대 폰트랩 스튜디오]를 재구성했습니다.</div>
            <a href="https://www.jungle.co.kr/magazine/6188" class="link" target="_blank">https://www.jungle.co.kr/magazine/6188</a>
          </div>
        </div>
      </div>
    </section>
    <section class="section-3" id="font-1">
      <div class="section-contents-wrapper">
        <div class="section-title align-left">
          <span class="title underline">가비아 솔미체</span>
          <span class="download-link">
            <a href="https://static.gabia.com/fonts/project/fonts/Download-font/GabiaSolmee.zip">다운로드 <i class="far fa-arrow-to-bottom"></i></a>
          </span>
        </div>
        <div class="section-description description align-left">
          <p>가비아 솔미체는 ‘값싸고 흔한 사인펜으로 쓴 것 같은’ 글꼴입니다. 그만큼 친근함이 매력인 글꼴입니다.<br>
            펜을 쥔 손의 각도에 따라 획이 자연스럽게 구부러지는 사인펜의 특성을 반영했습니다.</p>
        </div>
        <FontCharacter base-color="#FF9F64" :character-list="solmeeData.list" :character-info="solmeeData.info">
          <img src="https://static.gabia.com/fonts/project/image/font_characters/solmee.svg">
        </FontCharacter>
      </div>
    </section>
    <section class="section-4" id="font-2">
      <div class="section-contents-wrapper">
        <div class="section-title align-left">
          <span class="title underline">가비아 봄바람체</span>
          <span class="download-link">
            <a href="https://static.gabia.com/fonts/project/fonts/Download-font/GabiaBombaram.zip">다운로드 <i class="far fa-arrow-to-bottom"></i></a>
          </span>
        </div>
        <div class="section-description description align-left">
          <p>가비아 봄바람체는 봄바람에 날리는 듯한 경쾌한 붓놀림을 구현한 글꼴입니다.<br>
            획의 끝이 날렵하게 삐치는 모양이 특징입니다.</p>
        </div>
        <FontCharacter base-color="#F2D328" :character-list="bombaramData.list" :character-info="bombaramData.info">
          <img src="https://static.gabia.com/fonts/project/image/font_characters/bombaram.svg">
        </FontCharacter>
      </div>
    </section>
    <section class="section-5" id="font-3">
      <div class="section-contents-wrapper">
        <div class="section-title align-left">
          <span class="title underline">가비아 납작블럭체</span>
          <span class="download-link">
            <a href="https://static.gabia.com/fonts/project/fonts/Download-font/GabiaNapjakBlock.zip">다운로드 <i class="far fa-arrow-to-bottom"></i></a>
          </span>
        </div>
        <div class="section-description description align-left">
          <p>가비아 납작블럭체는 획 하나하나를 또박또박 끊어서 쓴 것이 특징입니다.<br>
            자소마다 글줄의 높이 차이를 주어 생동감, 박자감이 느껴지게 했습니다.</p>
        </div>
        <FontCharacter base-color="#B080FD" :character-list="napjakBlockData.list" :character-info="napjakBlockData.info">
          <img src="https://static.gabia.com/fonts/project/image/font_characters/napjakBlock.svg">
        </FontCharacter>
      </div>
    </section>
    <section class="section-6 section-sample-editor" id="font-sample">
      <div class="section-contents-wrapper">
        <div class="section-title  align-left">
          <span class="title">써보기</span>
        </div>
        <div class="section-title description"></div>
        <div class="section-contents-editor line-card-wrapper" ref="editor" :class="[theme]">
          <div class="content-editor-wrapper">
            <div class="sample-text-editor" ref="note"
                 spellcheck="false"
                 :contenteditable="true" :class="[selectedFont]"
                 :placeholder="`가비아 ${selectedFontText}를 사용해 보세요.`"
                 :style="{ fontSize: `${editorValue.fontSize}px`}" @keydown.enter="esterEgg">
            </div>
          </div>
          <div class="text-editor-control">
            <div class="control-font-family">
              <ButtonControl :button-list="fontList" :active-color="`green`" @select="setFontFamily" />
            </div>
            <div class="control-font-size">
              <SliderControl :min-value="30" :max-value="100" v-model="editorValue.fontSize" @update="setFontSize"/>
            </div>
            <div class="control-theme">
              <ButtonControl :button-list="themeList" :active-color="`purple`" @select="setTheme" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer />
  </ScrollKeyFrame>
</template>

<script>
import ScrollKeyFrame from '@/Modules/ScrollKeyFrame/scrollKeyFrame.vue';
import FontCharacter from '@/components/FontCharacter.vue';
import Footer from '@/components/Footer.vue';
import SliderControl from '@/Modules/sliderControl/sliderControl.vue';
import ButtonControl from '@/Modules/sliderControl/buttonControl.vue';

export default {
  name: 'Font2014',
  components: {
    ScrollKeyFrame, FontCharacter, Footer, SliderControl, ButtonControl,
  },
  data() {
    return {
      theme: 'light',
      scrollTop: 0,
      selectedId: 0,
      autoState: null,
      interval: 5000, // ms
      sectionList: [
        { title: '질문과 답변', target: '#qna' },
        { title: '가비아 솔미체', target: '#font-1' },
        { title: '가비아 봄바람체', target: '#font-2' },
        { title: '가비아 납작블럭체', target: '#font-3' },
        { title: '써보기', target: '#font-sample' },
      ],
      qnaList: [
        {
          id: 0,
          question: '전용서체를 개발하게 된 배경은?',
          answer: '‘전용’서체라는 표현보다는 ‘글꼴, 웹 인프라 공유물’로 분류하는 편이 적합할 듯합니다. 웹에서 사용되고 있는 글꼴에 여러 가지 개성을 주고, 자유도를 높이기 위해 개발된 것이니까요. 향후에도 비슷한 형식과 취지를 가지고, 글꼴을 지속적으로 개발할 예정입니다.',
        },
        {
          id: 1,
          question: '국민대 폰트랩 스튜디오와의 협업 과정이 궁금합니다.',
          answer: '가비아는 국민대 글꼴 수업에 참여한 몇몇 학생들과 폰트랩 스튜디오를 꾸렸습니다. 이렇게 결성된 폰트랩 스튜디오는 2014년 9월부터 2015년 7월까지 약 11개월간 사업을 진행했습니다. 이지원 국민대 시각디자인학과 교수가 폰트랩을 총괄 지도했습니다. 또한 정솔미, 한동민, 이기훈이 주 연구자, 박준영 가비아 디자이너가 부 연구자로 프로젝트에 참여했습니다.',
        },
        {
          id: 2,
          question: '협업의 결과 탄생한 서체 3종과 가비아의 연결고리는 무엇인가요?',
          answer: '‘자유로움’이라고 생각합니다. 가비아의 철학은 누구나 쉽고 자유롭게 IT 세상을 누릴 수 있도록 돕는 것입니다. 가비아 글꼴에는 ‘쉬움, 자유로움, 가벼움’이라는 가비아의 정신이 오롯이 담겨있습니다.',
        },
      ],
      solmeeData: {
        info: {
          korean: { text: '2,360자', title: '한글자소' },
          english: { text: '52자', title: '영문자소' },
          number_spacial: { text: '68자', title: '숫자 및 기호 활자' },
          otf_size: { text: '644KB', title: 'OTF 용량' },
        },
        list: [
          { id: 0, contents: '펜을 쥔 각도에 따라 굽은 획', pos: { top: '45%', left: '15%' } },
          { id: 1, contents: '사인펜 특유의 뭉툭하고 동그란 돌기', pos: { top: '68%', left: '22%' } },
          { id: 2, contents: '시각적으로 닮은 가로획과 세로획의 굵기', pos: { top: '45%', left: '43.5%' } },
          { id: 3, contents: '일정하게 적용된 가로 기울기', pos: { top: '33%', left: '59.5%' } },
          { id: 4, contents: '간결하게 이어진 쌍자음', pos: { top: '31%', left: '89.5%' } },
        ],
      },
      bombaramData: {
        info: {
          korean: { text: '2,360자', title: '한글자소' },
          english: { text: '52자', title: '영문자소' },
          number_spacial: { text: '68자', title: '숫자 및 기호 활자' },
          otf_size: { text: '547KB', title: 'OTF 용량' },
        },
        list: [
          { id: 0, contents: '획의 시작점을 나타내는 돌기', pos: { top: '64%', left: '10%' } },
          { id: 1, contents: '멈춰 눌러 쓴 부드러운 맺음', pos: { top: '27%', left: '26%' } },
          { id: 2, contents: '다음 글자의 초성을 향해 접히는 맺음', pos: { top: '70%', left: '60.5%' } },
          { id: 3, contents: '경쾌하게 맞닿은 세부 형태', pos: { top: '42%', left: '72%' } },
          { id: 4, contents: '붓놀림에 따라 유기적으로 연결되는 획', pos: { top: '47%', left: '89%' } },
        ],
      },
      napjakBlockData: {
        info: {
          korean: { text: '2,360자', title: '한글자소' },
          english: { text: '52자', title: '영문자소' },
          number_spacial: { text: '68자', title: '숫자 및 기호 활자' },
          otf_size: { text: '1,331KB', title: 'OTF 용량' },
        },
        list: [
          { id: 0, contents: '획을 연결하지 않고 끊어서 분리', pos: { top: '53%', left: '8.5%' } },
          { id: 1, contents: '글줄의 리듬감을 살리는 높이 차이', pos: { top: '66%', left: '24.5%' } },
          { id: 2, contents: '유기적 우아함이 묻어나는 미세한 곡선', pos: { top: '29%', left: '38.5%' } },
          { id: 3, contents: '완만한 곡선으로 처리된 꺾임', pos: { top: '32%', left: '59%' } },
          { id: 4, contents: '펜촉 기울기와 일치하는 형태', pos: { top: '44%', left: '89.5%' } },
        ],
      },
      selectPoint: -1,
      selectedFont: 'solmee',
      selectedFontText: '솔미체',
      editorValue: {
        fontSize: 100,
      },
      fontList: [
        { title: '솔미체', name: 'solmee', addText: true },
        { title: '봄바람체', name: 'bombaram', addText: true },
        { title: '납작블럭체', name: 'napjakBlock', addText: true },
      ],
      themeList: [
        { title: '밝음', name: 'light', addText: false },
        { title: '어두움', name: 'dark', addText: false },
      ],
    };
  },
  methods: {
    setQna(target) {
      this.autoPlay(false);
      this.selectedId = target - 1;
    },
    autoPlay(value = true) {
      if (!value) {
        clearInterval(this.autoState);
      } else {
        this.autoState = setInterval(() => {
          this.selectedId = this.selectedId === 2 ? 0 : this.selectedId + 1;
        }, this.interval);
      }
    },
    setFontFamily(font) {
      this.selectedFont = font.name;
      this.selectedFontText = font.title;
    },
    setTheme(type) {
      this.theme = type.name;
    },
    setFontSize(payload) {
      this.editorValue.fontSize = payload;
    },
    esterEgg(e) {
      const text = e.target.textContent;
      if (this.selectedFont === 'bombaram' && this.theme === 'dark' && this.editorValue.fontSize <= 30 && text === '돼봬') {
        this.$router.push({ name: 'MatterTest' });
      }
    },
  },
};

</script>

<style lang="scss" scoped>
#Font2014 {
  #qna {
    background: url('https://static.gabia.com/fonts/project/image/bg_image_2014_1.svg'), url('https://static.gabia.com/fonts/project/image/bg_image_2014_2.svg') ;
    background-repeat: no-repeat;
    background-position: 28% -6%, 78% 98%;
  }
  .section-contents-wrapper {
    width: 980px;
    margin: 0 auto;
  }
  .section-contents-tab {
    margin:0 auto;
    position: relative;
    width: 924px;
    padding-top: 150px;
    .tab-control-menu {
      display: flex;
      position: absolute;
      right: 0;
      top: -120px;
      .tab-control-item {
        display: flex;
        align-items: center;
        font-size: 22px;
        .control-number {
          cursor: pointer;
          display: block;
          padding: 0 24px;
        }
        .active-line {
          display: block;
          width: 0;
          height: 1px;
          background-color: #0A0A0A;
          transition: width 250ms ease;
        }
      }
      .active {
        font-weight: 900;
        .active-line {
          width: 72px;
        }
      }
    }
    .tab-contents-panel {
      width: 924px;
      min-height: 525px;
      .panel-header {
        padding: 48px 50px;
        background-color: #FC64F3;
        display: flex;
      }
      .panel-contents {
        padding: 50px;
      }
    }
    .reference-text {
      margin-top: 30px;
    }
  }
  .section-contents-editor {
    position: relative;
    width: 100%;
    height: 500px;
    background-color: #fff;
    margin-top: 100px;
    .text-editor-control {
      position: absolute;
      width: 100%;
      top: 100%;
      margin-top: 80px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &> div {
        width: 200px;
      }
    }
    .sample-text-editor {
      position: absolute;
      width: 100%;
      max-height: 100%;
      padding: 50px;
      z-index: 100;
      font-size: 100px;
      outline: none;
      text-align: center;
      overflow-y: auto;
      color: #555555;
      &.solmee {
        font-family: 'Solmee';
      }
      &.bombaram {
        font-family: 'BombaramOTF';
      }
      &.napjakBlock {
        font-family: 'NapjakBlock';
      }
    }
    &.dark {
      background-color: #1f1f1f;
      .sample-text-editor {
        color: #bababa;
      }
      [contenteditable=true]:empty:before {
        content: attr(placeholder);
        display: block;
        color: #6f6f6f;
      }
    }
    [contenteditable=true]:empty:before {
      content: attr(placeholder);
      display: block;
      color: #ddd;
    }
    .content-editor-wrapper {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 99;
      display: flex;
      align-items: center;
      justify-content: center;
      &:before {
        content: url('https://static.gabia.com/fonts/project/image/db_quotation.svg');
        position: absolute;
        top:0;
        left:0;
        transform: translate(-50%, -50%);
      }
      &:after {
        content: url('https://static.gabia.com/fonts/project/image/db_quotation.svg');
        position: absolute;
        bottom:0;
        right:0;
        transform: translate(50%, 50%) rotate(180deg);
      }
    }
  }
}

</style>
